// NexusTable/createRowData.js

import { CATEGORY } from "../../modules/constants"
import { getRowFromBasics, getRowFromCapacity } from "../../components/layout/NexusTableFunctions"
import { getFilteredItems } from "./GetFilteredItems"

export const createNexusRowData = props => {
  // console.log('createNexusRowData props:', props)
  const { isCompany, showSecondDegree, stats } = props
  const rows = []

  const filteredItems = getFilteredItems(props)
  // console.log('filteredItems:',filteredItems)
  filteredItems.forEach(item => {
    // console.log('item:', item)
    const showConnection = !showSecondDegree
      ? item.level === 1
      : item.level === 2 && (isCompany
        ? item.entity.category === CATEGORY.COMPANY
        : item.entity.category === CATEGORY.PERSON)

    if (showConnection) {
      const indexBit = item.entity.companyProps?.lse?.indexBit

      if (item.hasConnection)
        rows.push(getRowFromCapacity({ ...props, indexBit, role: item.role, item }))
      else {
        rows.push(getRowFromBasics({ ...props, item, roleDescription: item.role.roleDescription }))
      }

      ++stats.numRows
      ++stats.numRoles
    }
  })

  return rows
}

